import { isFixed, getOffset } from '@/utils/dot-helpers'

export default function calculatePosition(
  target,
  originalEvent,
  documentOffset
) {
  const offset = getOffset(target)
  const offsetParent = target.offsetParent

  devOnlyHighlightParent(offsetParent)

  const offsetFromElement = {
    x: originalEvent.clientX - offset.left,
    y: originalEvent.clientY - offset.top
  }

  return {
    fromDocument: documentOffset,
    fromEl: offsetFromElement,
    isFixed: isFixed(target),

    // Attempt to position within elemetn based off %.
    tether: {
      x: (offsetFromElement.x / target.offsetWidth) * 100,
      y: ((offsetFromElement.y + 7) / target.offsetHeight) * 100
    }
  }
}

const devOnlyHighlightParent = offsetParent => {
  // if (process.env.NODE_ENV !== 'production' && offsetParent) {
  //   offsetParent.style.outline = '2px solid green'
  // } else {
  //   document.body.style.outline = '2px solid green'
  // }
}
